import type { Channel } from '../../utils/get-channels-from-pypes';
import { integratorIdOf } from './call-transcript';
import type { VoiceLine } from './validate-api';

/**
 * Each voice channel the browser can call through, for "Call me". Kept out of
 * RunChannel on purpose: runs are saved. A line holds no Twilio credential and
 * the auth token is not read here: the server loads it
 * (`bobcat/src/server-only/voice/voice-line.ts`). Limitation: a channel whose config has
 * an account sid and a number but no token still gets a line here, and the
 * server then answers 403 when the call is placed (`voiceAccess`).
 */
export const buildVoiceLines = (
  channels: readonly Channel[] | null | undefined
): Map<string, VoiceLine> => {
  const out = new Map<string, VoiceLine>();
  (channels ?? []).forEach((c) => {
    const cfg = c.twilioVoiceConfig;
    if (c.type === 'twilio_voice' && cfg?.account_sid && cfg.phone_number) {
      out.set(c.id, {
        channelId: c.id,
        number: cfg.phone_number,
        ...(integratorIdOf(cfg.init_call_webhook_url)
          ? {
              integratorId: integratorIdOf(cfg.init_call_webhook_url) as string,
            }
          : {}),
      });
    }
  });
  return out;
};
